import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { CTAButton } from "./CTAButton";
const enterEase = [0.22, 1, 0.36, 1] as const;
export function PriceOffer() {
  const reduceMotion = useReducedMotion();
  return <div className="mt-9 border-t border-[#bcd7f0] pt-6 text-center sm:text-left" data-id="element-257" data-mp="3f0yj2fz40qjf">
      <motion.div initial={reduceMotion ? false : {
      opacity: 0
    }} whileInView={reduceMotion ? undefined : {
      opacity: 1
    }} viewport={{
      once: true,
      amount: 0.3
    }} transition={{
      duration: 0.35,
      ease: enterEase
    }} data-id="element-258" data-mp="3jy6rvpydbi80">
        <span className="inline-flex rounded-full bg-[#e2f7ed] px-3 py-1 text-[11px] font-extrabold tracking-[0.1em] text-[#08714f]" data-id="element-259" data-mp="2w9xad086tgmo">50% OFF</span>
      </motion.div>
      <motion.div className="mt-3" initial={reduceMotion ? false : {
      opacity: 0,
      y: 6
    }} whileInView={reduceMotion ? undefined : {
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      amount: 0.3
    }} transition={{
      duration: 0.42,
      delay: 0.08,
      ease: enterEase
    }} data-id="element-260" data-mp="31al9k96kl3rz">
        <div className="flex items-end justify-center gap-3 sm:justify-start" data-id="element-261" data-mp="3uc6tyi4iasp6">
          <span className="mb-1.5 text-sm font-semibold text-[#657189] line-through" data-id="element-262" data-mp="3qcpmxk9flnhw">$39.980 ARS</span>
          <span className="text-[42px] font-extrabold leading-none tracking-[-0.07em] text-[#081a37]" data-id="element-263" data-mp="3lb08rvqwwtpl">$19.990</span>
          <span className="mb-1 text-sm font-bold text-[#657189]" data-id="element-264" data-mp="3gcysfikvf8ht">ARS</span>
        </div>
        <p className="mt-2 text-sm font-medium text-[#657189]" data-id="element-265" data-mp="3bfoufejf1oid">Pago único · Sin suscripciones</p>
        <p className="mt-1 text-xs font-semibold text-[#657189]" data-id="element-266" data-mp="36lud2hra9lmg">Acceso inmediato y de por vida</p>
      </motion.div>
      <motion.div initial={reduceMotion ? false : {
      opacity: 0,
      y: 8
    }} whileInView={reduceMotion ? undefined : {
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      amount: 0.3
    }} transition={{
      duration: 0.45,
      delay: 0.16,
      ease: enterEase
    }} data-id="element-267" data-mp="32m2443xz9dgk">
        <CTAButton href="https://formulaemprendedora.shop/cart/46985494692037:1" tone="green" shimmer pulse className="mt-6 min-h-[60px] w-full text-[13px] sm:w-full" data-id="element-268" data-mp="2npug0sjg7rw0">QUIERO EMPEZAR AHORA</CTAButton>
        <p className="mt-3 text-center text-[13px] font-semibold text-[#657189]" data-id="element-269" data-mp="2j0terqm0h4cj">✓ Acceso inmediato después del pago</p>
        <p className="mt-1 text-center text-xs text-[#657189]" data-id="element-270" data-mp="252246e6cy0t5">Pago único · Acceso de por vida</p>
      </motion.div>
    </div>;
}